export const checkProdMode = () => {
    const prodUrl = 'junior.mts.ru';
    return window.location.hostname === prodUrl;
};
